<div class="spinner-container" [class.is-loading]="loading">
	<ng-content></ng-content>
	
	@if (loading) {
		<div class="spinner-overlay">
			<div class="spinner-ring"></div>
		</div>
	}
</div>

